// istanbul ignore file
import { checkPermissions as _checkPermissions, preCheckPermissions, preCheckPermissionsForBrickOrRoute } from "./checkPermissions.js";
import { MessageDispatcher } from "./websocket/MessageDispatcher.js";
import * as authV3 from "./auth.js";
import { authV2Factory } from "./auth-v2.js";
import * as _checkInstalledApps from "./checkInstalledApps.js";
export { _checkInstalledApps as checkInstalledApps };
import * as _flowApi from "./flowApi/index.js";
export { _flowApi as flowApi };
import * as _menu from "./menu/index.js";
export { _menu as menu };
import * as _analytics from "./analytics/index.js";
export { _analytics as analytics };
export const checkPermissions = Object.freeze({
  checkPermissions: _checkPermissions,
  preCheckPermissions,
  preCheckPermissionsForBrickOrRoute
});
export const messageDispatcher = new MessageDispatcher();
export const auth = authV2Factory() || authV3;
//# sourceMappingURL=index.js.map